module.exports = __webpack_public_path__ + "datedropper.svg?0fd93e84a7a256585a9a426061d0c742";